module.exports = __webpack_public_path__ + "img/area-comum-02.207786f6.png";